import React from "react";

export const ColoredText = (color: string, text: string, fontWeight = 'normal', reactKey = "") => (<span key={reactKey} style={{ color: `${color}`, fontWeight: `${fontWeight}` }}>{text}</span>)
export const BoldText = (text: string) => (<span key={text} style={{ fontWeight: `bold` }}>{text}</span>)